import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

import Home from "../views/Home.vue";
import Contact from "../views/Contact.vue";
import Cup from "../views/Cup.vue";
import OnBoarding from "../views/OnBoarding.vue";
import Admin from "../views/Admin.vue";
import Customer from "../views/Customer.vue";

const fb = require("../firebase.js");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
  },
  {
    path: "/cup/:id",
    name: "Cup",
    component: Cup,
  },
  {
    path: "/:customer/:id",
    name: "Customer",
    component: Customer,
  },
  {
    path: "/introduction",
    name: "OnBording",
    component: OnBoarding,
  },
  {
    path: "/contact",
    name: "Contact",
    component: Contact,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const currentUser = fb.firebase.auth().currentUser;
  if (to.name !== "OnBording" && !currentUser) {
    store.commit("setRouteParams", to.params);
    next("/introduction");
  } else if (currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
